module.exports = __webpack_public_path__ + "img/lock-alt.70e8dcb6.svg";